<!--
 * @Author: Merlin
 * @Date: 2023-12-07 11:12:37
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-23 19:22:54
 * @Description: 
-->
<template>
    <button class="button-3d"
        :disabled="disabled"
        :class="[
            oProps.color,
            oProps.size + '-size',
            ...aClassName,
        ]"
    >
        <span class="button-3d__outer">
            <span class="button-3d__inner">
                <em class="row-01" >
                    <i class="icon-coat" v-if="$slots.icon">
                        <slot name="icon"> <!-- 插入图标 --> </slot>
                    </i>
                    <span>
                        <slot><!-- 插入文字 --></slot>
                    </span>
                </em>
                <!-- ▲行1行  ▼第2行 -->
                <small class="row-02" v-if="$slots.secondRow">
                    <slot name="secondRow"><!-- 插入文字 --></slot>
                </small>
            </span>
        </span>
    </button>
</template>

<script setup>
const oProps = defineProps({
    color: {
        type: String,
        default: 'red', // gray 颜色非3D效果 
    },
    fullWidth: {
        type: Boolean,
        default: false,
    },
    size: {
        /*
            规格：高度px
            'xs': 22 -未开发
            'sm': 28
            'md': 36（默认 💎） 
            'lg': 48
            'xl': 62 -未开发
        */
        type: String,
        default: 'md',
    },
    disabled: {
        type: Boolean,
    },
});

const aClassName = computed(()=>{
    const aResult = [];
    if (oProps.fullWidth) aResult.push('full-with');
    return aResult;
});
// const instance = getCurrentInstance();
// const slots = instance.slots;


</script>


<style scoped lang="scss">
.be-center{
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
}

.button-3d{
    font-variant-numeric: lining-nums tabular-nums;
    font-weight: 600;
    min-width: 80px; // ←观察此行，将来修改数值，或删除它
    vertical-align: bottom;
    &[class~=full-with]{
        width: 100%;
    }
    &+.button-3d{
        margin-left: 10px;
    }
    &+.full-with{
        margin-left: 0px;
        margin-top: 10px;
    }
}

.button-3d > .button-3d__outer{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    position: relative;
    transition: transform .1s ease-in-out;
    z-index: 1;
    border-radius: var(--radius);
    .button-3d__inner{
        line-height: 1.1;
        flex-direction: column;
        @extend .be-center;
        .row-01{
            flex-direction: row;
            font-style: normal;
            color: white; // 补充于 2024.06.05 19:50:36 星期三 
            @extend .be-center;
            .icon-coat{
                margin-right: 4px;
                width: 20px;
                height: 20px;
                &:deep(>*){
                    max-width: 100%;
                    max-height: 100%;
                }
            }
        }
        .row-02{
            color: #ffffffb3;
            font-size: 12px;
        }
        // &[class~=text_double]{
        //     opacity: 1;
        // }
    }
}


// ▼尺寸控制 ----------------------
.button-3d{
    border-radius: var(--radius);
    padding-bottom: var(--padding-bottom);
    &[class~=sm-size]{
        --radius: 6px;
        --padding-bottom: 3px; 
        font-size: 11px;
        min-width: 70px; // 覆盖默认值 
        .button-3d__outer{
            padding-left: 12px;
            padding-right: 12px;
            min-height: calc(28px - var(--padding-bottom));
        }
    }
    &[class~=md-size]{
        --radius: 8px;
        --padding-bottom: 3px;
        font-size: 12px;
        .button-3d__outer{
            padding-left: 12px;
            padding-right: 12px;
            min-height: calc(36px - var(--padding-bottom));
        }
    }
    &[class~=lg-size]{
        --radius: 8px;
        --padding-bottom: 4px;
        font-size: 14px;
        .button-3d__outer{
            padding-left: 14px;
            padding-right: 14px;
            min-height: calc(48px - var(--padding-bottom));
        }
    }
}


// ▼颜色控制 -----------------------
.button-3d{
    &[class~=gray]{
        --padding-bottom: 0px;
        background: var(--color_grey-60);
        .button-3d__outer{
            transform: translateY(0) !important; // 永不动 
            background: transparent;
        }
    }
    &[class~=red]{
        background-color: #61001d;
        .button-3d__outer{
            background: linear-gradient(1turn,#c4003b .8%,#fb1949);
            box-shadow: 0 3px 16px #ff234180, inset 0 4px 3px #ffffff4d;
        }
    }
    &[class~=blue]{
        background-color: #003293;
        .button-3d__outer{
            background: linear-gradient(1turn,#0c5eff .8%,#1398f9);
            box-shadow: 0 3px 28px #2283f666, inset 0 3px 3px #ffffff4d;
        }
    }
    &[class~=green]{
        background-color: #004e11;
        .button-3d__outer{
            background: linear-gradient(1turn,#009420 .8%,#1bb83d);
            box-shadow: 0 2px 24px #1bb83d66,inset 0 3px 3px #ffffff4d;
        }
    }
}


// ▼ hover ---------------------------------------
.button-3d:not([disabled]):hover{
    .button-3d__outer{
        transform: translateY(-2px);
    }
    &[class~=gray] {
        .button-3d__outer{
            background-color: var(--color_grey-50);
        }
    }
    &[class~=red]{
        .button-3d__outer{
            background: linear-gradient(3360deg,#db0a49 .8%,#fb2b57);
            box-shadow: 0 3px 20px #ff234199,inset 0 4px 4px #ffffff5e;
        }
    }
    &[class~=blue]{
        .button-3d__outer{
            background: linear-gradient(1turn,#236eff .8%,#34a7fb);
            box-shadow: 0 3px 20px #2283f699,inset 0 4px 4px #ffffff5e;
        }
    }
}


// ▼ active -----------------------------------
.button-3d:not([disabled]):active{
    .button-3d__outer{
        transform: translateY(1px);
    }
    &[class~=gray] {
        .button-3d__outer{
            background-color: var(--color_grey-70);
        }
    }
    &[class~=red]{
        .button-3d__outer{
            background: linear-gradient(1turn,#c4003b .8%,#fb1949);
            box-shadow: 0 3px 16px #ff234166,inset 0 3px 3px #ffffff4d;
        }
    }
    &[class~=blue]{
        .button-3d__outer{
            background: linear-gradient(1turn,#0c5eff .8%,#1398f9);
            box-shadow: 0 3px 16px #2283f666,inset 0 3px 3px #ffffff4d;
        }
    }
}

</style>


